import axios from "shared/tools/axiosMultisite";

function getPreferencesObject() {
	return {
		productsOrderPeriod: 0,
	};
}

export default {
    state: () => ({
        preferredPeriodInDays: '',
		preferencesHaveBeenFetched: false,
		preferences: {
			productsOrderPeriod: 0,
		},
    }),
    getters: {
        getPreferredPeriodInDays: (state) => {
            return state.preferences.productsOrderPeriod;
        },
		getPreferencesHaveBeenFetched: (state) => {
			return state.preferencesHaveBeenFetched;
		},
		getPreferences: (state) => {
			return state.preferences;
		},
    },
    mutations: {
		setPreferencesHaveBeenFetched: (state, preferencesHaveBeenFetched) => {
			state.preferencesHaveBeenFetched = preferencesHaveBeenFetched;
		},
		setPreferences: (state, preferences) => {
			state.preferences = preferences;
		},
    },
    actions: {
		fetchPreferences: async ({ commit }) => {
			return axios.get('/api/consumeraccount/getconsumerpreference')
				.then(response => {
					if (response.data.isError || response.data.isEmpty) {
						commit('setPreferencesHaveBeenFetched', false);
						commit('setPreferences', null);
					}
					else {
						commit('setPreferencesHaveBeenFetched', true);
						commit('setPreferences', response.data);
					}
				});
		},
		setPreferences: async ({ commit, state }, preferences) => {
			if (!state.preferences) {
				// use post
				return axios.post('/api/consumeraccount/createconsumerpreference', preferences)
					.then(response => {
						commit('setPreferences', preferences);
					})
			}
			else {
				// use put
				return axios.put('/api/consumeraccount/updateconsumerpreference', preferences)
					.then(response => {
						commit('setPreferences', preferences);
					})
			}
		},
		setPreferredPeriodInDays: async ({ dispatch, state }, days) => {
			let payload = state.preferences || getPreferencesObject();
			payload.productsOrderPeriod = days;
			return dispatch('setPreferences', payload);
		},
    },
}
